import { createContext, useContext } from 'react';
import { useOccurrences as __useOccurrences } from 'src/hooks/useOccurrences';

export const Context = createContext<{
	useOccurrences: ReturnType<typeof __useOccurrences>;
}>({
	useOccurrences: {
		occurrences: [],
		lastPeriodOccurrences: [],
		period: {
			inf_date: '',
			sup_date: '',
		},
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		setOccurrencesPeriod: () => {},
		isLoading: false,
	},
});

export default function useOccurrences() {
	const { useOccurrences, } = useContext(Context);
	return useOccurrences;
}
